import { render, staticRenderFns } from "./LocationTabContent.vue?vue&type=template&id=542c6bd8&scoped=true&"
import script from "./LocationTabContent.vue?vue&type=script&lang=js&"
export * from "./LocationTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c6bd8",
  null
  
)

export default component.exports